import zipState from 'zip-state';

export const stateNames = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
} as const;

type StateAbbreviation = keyof typeof stateNames;
type StateName = (typeof stateNames)[StateAbbreviation];

type StateOption = {
  value: StateAbbreviation;
  label: StateName;
};

export function getState(zipCode: string): StateAbbreviation | null {
  const state = zipState(zipCode);
  if (state == null) return null;
  if (!stateNames.hasOwnProperty(state)) return null;
  return state as StateAbbreviation;
}

export const ALLOWED_STATES = new Set<StateAbbreviation>(['NY', 'FL']);

export const insuranceStateOptions: StateOption[] = (
  Object.keys(stateNames) as StateAbbreviation[]
).map((value) => ({
  value,
  label: stateNames[value],
}));
